export enum Temperature {
  DIRECT_TRANSLATION = 0.5,
  REPHRASE = 1.0,
  DUPLICATE_TRANSLATION = 0.6
}
